// src/utils/inputFormatter.js

/**
 * Formatea la cadena de dígitos sin signos a un tiempo legible según la precisión deseada.
 * Soporta precisiones: 'seconds', '1/5', '1/10', '1/100', '1/1000', '1/10000'.
 *
 * Reglas:
 * - 1 o 3 dígitos => inválido (cadena vacía)
 * - 2 dígitos => segundos, fracción nula ("XX.00", "XX.0", etc.)
 * - >= 4 dígitos => agrupa como HH:MM:SS.fraction o MM:SS.fraction o SS.fraction según longitud.
 */

const decimalsMap = {
    seconds:   0,
    '1/5':     1,
    '1/10':    1,
    '1/100':   2,
    '1/1000':  3,
  };
  
  export function formatByPrecision(input, precision) {
    // 1) Extraer solo dígitos
    let digits = String(input || '').replace(/\D/g, '');
    // 2) Quitar ceros a la izquierda
    digits = digits.replace(/^0+/, '') || digits;
  
    const D = decimalsMap[precision] ?? 2;
  
    // 3) Casos inválidos
    if (digits.length === 1 || digits.length === 3) return '';
  
    // 4) Dos dígitos => segundos con fracción cero
    if (digits.length === 2) {
      return `${digits}.${'0'.repeat(D)}`;
    }
  
    // 5) Agrupar para >= 4 dígitos
    // Fracción = últimas D cifras
    const frac = digits.slice(-D);
    const rest = digits.slice(0, -D);
  
    // Separar HH / MM / SS
    const secStr = rest.slice(-2).padStart(2, '0');
    const minRest = rest.slice(0, -2);
    const minStr = minRest.slice(-2).padStart(2, '0');
    const hrStr = minRest.slice(0, -2);
  
    // Construir
    if (hrStr.length > 0) {
      const hours = parseInt(hrStr, 10);
      return `${hours}:${minStr}:${secStr}.${frac}`;
    }
    if (minRest.length > 0) {
      const minutes = parseInt(minStr, 10);
      return `${minutes}:${secStr}.${frac}`;
    }
    // Solo segundos
    const seconds = parseInt(secStr, 10);
    return `${seconds}.${frac}`;
  }
  